import React from "react";
import ReactEcharts from "echarts-for-react";
import {
  formatCurrency,
  formatCurrencyShort,
  formatDayShort,
  formatInteger,
} from "./dashboardFormat";

// Receita acumulada por dia.
//
// Acumulada, e não o valor de cada dia: o que a operação acompanha é o quanto o
// evento já vendeu, e a curva mostra de uma vez o total, o ritmo e os dias
// parados. O valor do dia continua visível, no tooltip.
//
// Nenhuma linha de meta: o evento não tem meta cadastrada, e uma inventada só
// enganaria a leitura.

export default function RevenueChart({ daily = [] }) {
  const days = daily.map((row) => formatDayShort(row.date));
  const cumulative = daily.map((row) => row.cumulativeAmount);

  const options = {
    grid: { left: 70, right: 24, top: 24, bottom: 40 },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "line", lineStyle: { color: "#556ee6", opacity: 0.4 } },
      formatter: (params) => {
        const point = params?.[0];
        if (!point) return "";
        const row = daily[point.dataIndex] ?? {};
        return [
          `<strong>${point.axisValue}</strong>`,
          `${formatCurrency(row.cumulativeAmount)} acumulado`,
          `+ ${formatCurrency(row.amount)} · ${formatInteger(row.tickets)} ingresso(s) no dia`,
        ].join("<br/>");
      },
    },
    xAxis: {
      type: "category",
      data: days,
      boundaryGap: false,
      axisLine: { lineStyle: { color: "#e2e6ef" } },
      axisTick: { show: false },
      axisLabel: { color: "#74788d", fontSize: 11 },
    },
    yAxis: {
      type: "value",
      splitLine: { lineStyle: { color: "#eff2f7" } },
      axisLabel: {
        color: "#74788d",
        fontSize: 11,
        // Explícito: o eixo de valor é lido de baixo para cima comparando as
        // casas, e isso só funciona com os números terminando na mesma coluna.
        align: "right",
        formatter: (value) => formatCurrencyShort(value),
      },
    },
    series: [
      {
        name: "Receita paga",
        type: "line",
        data: cumulative,
        smooth: true,
        showSymbol: false,
        lineStyle: { color: "#556ee6", width: 2 },
        itemStyle: { color: "#556ee6" },
        areaStyle: { color: "#556ee6", opacity: 0.08 },
      },
    ],
  };

  if (daily.length === 0) {
    return (
      <div className="text-center text-muted py-5">
        Nenhuma venda paga registrada até agora.
      </div>
    );
  }

  return <ReactEcharts option={options} style={{ width: "100%", height: "300px" }} />;
}
